export const caseItems = [
  {
    id: "case-1",
    size: "lg",
    tag: "截图证据",
    title: "跨平台对比：同一段对话的三个版本截图并排核对",
    summary:
      "把三个来源的截图放在一起，逐条对照时间显示、头像与气泡顺序，标出不一致的位置。",
    image:
      "https://readdy.ai/api/search-image?query=dark%20archive%20room%20with%20large%20screen%20showing%20groups%20of%20image%20thumbnails%2C%20deep%20crimson%20accent%20light%2C%20warm%20amber%20details%2C%20moody%20cinematic%20editorial%20illustration%2C%20high%20contrast%2C%20no%20text&width=1000&height=760&seq=hjhl-case-01&orientation=landscape",
    materials: 46,
    comments: 218,
    updatedAt: "09-10",
  },
  {
    id: "case-2",
    size: "sm",
    tag: "录音文件",
    title: "录音节选与文字转写对照",
    summary: "2 段节选完成转写，标注关键时间点。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20audio%20waveform%20and%20microphone%20on%20dark%20surface%2C%20crimson%20and%20amber%20glow%2C%20cinematic%20editorial%20illustration%2C%20minimal%20composition%2C%20no%20text&width=700&height=560&seq=hjhl-case-02&orientation=landscape",
    materials: 18,
    comments: 96,
    updatedAt: "09-09",
  },
  {
    id: "case-3",
    size: "sm",
    tag: "文档材料",
    title: "多份材料扫描件并排比对",
    summary: "逐页摘要，标出字段差异位置。",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20scanned%20documents%20and%20paper%20sheets%20on%20a%20dark%20desk%2C%20warm%20amber%20side%20light%2C%20editorial%20cinematic%20illustration%2C%20high%20detail%2C%20no%20text&width=700&height=560&seq=hjhl-case-03&orientation=landscape",
    materials: 27,
    comments: 74,
    updatedAt: "09-09",
  },
  {
    id: "case-4",
    size: "sm",
    tag: "线索整理",
    title: "三个关键节点前后说法差异",
    summary: "时间线整理，标注前后表述变化。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20timeline%20threads%20connecting%20small%20cards%20and%20nodes%2C%20crimson%20and%20amber%20lighting%20on%20dark%20background%2C%20editorial%20cinematic%20illustration%2C%20no%20text&width=700&height=560&seq=hjhl-case-04&orientation=landscape",
    materials: 12,
    comments: 143,
    updatedAt: "09-08",
  },
  {
    id: "case-5",
    size: "sm",
    tag: "网友投稿",
    title: "被反复提及的细节清单",
    summary: "汇总投稿中重复出现的 9 条细节。",
    image:
      "https://readdy.ai/api/search-image?query=magnifying%20glass%20over%20documents%20and%20notes%20on%20dark%20surface%2C%20warm%20amber%20and%20crimson%20light%2C%20editorial%20cinematic%20illustration%2C%20no%20text&width=700&height=560&seq=hjhl-case-05&orientation=landscape",
    materials: 9,
    comments: 187,
    updatedAt: "09-08",
  },
  {
    id: "case-6",
    size: "sm",
    tag: "交叉验证",
    title: "截图与文件交叉验证索引",
    summary: "为每条关键细节找到对应材料编号。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20chat%20conversation%20bubbles%20and%20document%20icons%20floating%20on%20dark%20background%2C%20crimson%20accent%20and%20amber%20glow%2C%20editorial%20cinematic%20illustration%2C%20no%20text&width=700&height=560&seq=hjhl-case-06&orientation=landscape",
    materials: 33,
    comments: 129,
    updatedAt: "09-07",
  },
];